mainApp.component('safeSearch', {
	templateUrl: '/public/components/safe-search.component.html',
	bindings: {
		safeSearchSettings: '=',
	},
	controller: safeSearchController
});


function safeSearchController() {
	let ctrl = this;

	ctrl.$onInit = function () {
		ctrl.originalSettings = ctrl.safeSearchSettings;
	};
}
